import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { FILE_HOSTING } from '../../constants/general';
import FileHostingList from './FileHostingList';
import TitleBar from '../Shared/TitleBar';
import { Grid } from '@material-ui/core';
import PageUnauthorized from '../Shared/PageUnauthorized';
import { isAdmin } from '../../util/miscUtil';

const FileHostingLanding = inject(
  'AuthStore',
  'FileHostStore'
)(
  observer(({ AuthStore: authStore, FileHostStore }) => {
    useEffect(() => {
      return () => {
        FileHostStore.deleteStore();
      };
    }, [FileHostStore]);

    if (authStore?.roles && authStore.roles.length > 0 && !isAdmin(authStore?.roles)) {
      return <PageUnauthorized />;
    }

    return (
      <>
        {authStore?.roles && authStore.roles.length > 0 && isAdmin(authStore?.roles) && (
          <Grid container style={{ width: '95vw' }}>
            <TitleBar title={FILE_HOSTING.TITLE} currentPage={FILE_HOSTING.TITLE} paths={[{ path: '/', name: 'Home', onClickFunc: null }]} />
            <FileHostingList authStore={authStore} />
          </Grid>
        )}
      </>
    );
  })
);

export default FileHostingLanding;
